import { useCallback } from 'react';
import {
    confirmDialogAction,
    ConfirmDialogState,
} from '../../redux/slices/confirmDialogSlice';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { ConfirmDialogProps } from '../../models/ConfirmDialogProps';

const useConfirmDialog = () => {
    const state: ConfirmDialogState = useAppSelector(
        (state) => state.confirmDialog
    );
    const dispatch = useAppDispatch();

    const showDialog = useCallback((props: ConfirmDialogProps) => {
        if (props) {
            dispatch(confirmDialogAction.setConfirmDialog(props));
        } else {
            dispatch(confirmDialogAction.setConfirmDialog(null));
        }
    }, []);

    const closeDialog = () => {
        dispatch(confirmDialogAction.setConfirmDialog(null));
    };

    return { ...state, showDialog, closeDialog };
};

export default useConfirmDialog;
